import logLevel, { levels } from 'loglevel';

const defaultLogger = logLevel.getLogger('REACT');
defaultLogger.setDefaultLevel(levels.INFO);

const originalFactory = defaultLogger.methodFactory;

// manual prefix plugin
defaultLogger.methodFactory = function (methodName, level, loggerName) {
    const rawMethod = originalFactory(methodName, level, loggerName);
    const prefix = `[${loggerName}] ${methodName.toUpperCase()}:`;
    // binding to console object, to preserve reference to logging locations
    return rawMethod.bind(console, prefix);
};

// call setLevel method in order to apply plugin
defaultLogger.setLevel(defaultLogger.getLevel());

export default defaultLogger;
